import { speed } from 'Lib/speed/speed';
import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';
import { showPopupError } from 'Lib/show-popup-error/show-popup-error';

function postReviewDelete($parentItem, o) {
    $.post('/ajax/reviews/delete/', o, (data) => {
        let dataParse = data;

        if (Object.prototype.toString.call(dataParse) === '[object String]') {
            dataParse = JSON.parse(data);
        }

        if (typeof dataParse.STATUS === 'boolean' && typeof dataParse.MESSAGE === 'string') {
            if (dataParse.STATUS) {
                const deleteSpeed = speed * 2;

                if ($parentItem.length) {
                    $parentItem.css({ 'display': 'block' }).slideUp(deleteSpeed);

                    setTimeout(() => {
                        $parentItem.remove();
                    }, deleteSpeed);
                }

                setTimeout(() => {
                    if (dataParse.MESSAGE.length) {
                        showPopupError(dataParse.MESSAGE);
                    }
                }, deleteSpeed);
            } else {
                $parentItem.css({ 'opacity': 1 });

                if (dataParse.MESSAGE.length) {
                    showPopupError(dataParse.MESSAGE);
                }
            }
        }
    });
}

function setListeners() {
    $('.reviews__delete-link').on('click', function (e) {
        e.preventDefault();

        const $this = $(this);
        const o = {};
        const id = $this.attr('data-reviewid');

        if (isNoEmptyString(id)) {
            const dataFn = $this.attr('data-fn');
            const $parentItem = $this.closest('.reviews__item');

            if ($parentItem.length) {
                $parentItem.css({ 'opacity': 0.5 });
                o.reviewId = id;

                if (typeof dataFn === 'string') {
                    $.get(`/ajax/form/?fn=${dataFn}`, (data) => {
                        if (data.length) {
                            o.hash = data;
                            postReviewDelete($parentItem, o);
                        }
                    });
                } else {
                    postReviewDelete($parentItem, o);
                }
            }
        }
    });
}

$('body').on('bitrixDynamicComposite.eksmo', setListeners);

/* Редактирование отзыва из ЛК */
const cPanelActiveEdits = 'reviews__panel_active-edits';
const cReviewPanel = '.reviews__panel';
const cReviewEditsForm = '.reviews__edits-form';
const $reviewEditsForm = $(cReviewEditsForm);
const $reviewPanel = $(cReviewPanel);

$reviewPanel.on('click', '.reviews__edits-link', function () {
    const $parent = $(this).closest(cReviewPanel);

    $reviewEditsForm.removeClass('ajax-form_success');
    $reviewEditsForm.find('.ajax-form__response').remove();
    $parent.toggleClass(cPanelActiveEdits);
});

$reviewPanel.on('eksmoThisAjaxFormSuccess', '.reviews__edits-form', function () {
    const $this = $(this);
    const $parent = $this.closest(cReviewPanel);
    const text = $this.find('.reviews__about-textarea').val();

    $parent.toggleClass(cPanelActiveEdits);
    $parent.find('.reviews__text').html('');
    $parent.find('.reviews__text').append(text.replace(/\n/g, '<br>'));
});

/* Отправка комментария на комментарий */
$('.review__answer-btn').on('click', function () {
    const $parent = $(this).closest('.review');

    $parent.find('.review__answer-form-box').first().addClass('review__answer-form-box_active');
    $parent.find('.ajax-form').first().removeClass('ajax-form_success');
    $parent.find('.ajax-form__success').first().remove();
    $parent.find('.review__answer-text').first().removeClass('review__answer-text_active');
});

$('.review__answer-form-btn-cancel').on('click', function () {
    $(this).closest('.review ').find('.review__answer-form-box').removeClass('review__answer-form-box_active');
});

$('.review__answer-form').on('eksmoThisAjaxFormSuccess', function () {
    const $th = $(this);
    const $parent = $th.closest('.review__answer-form-box');

    $parent.removeClass('review__answer-form-box_active');
    $parent.prev().addClass('review__answer-text_active');

    if ($th.hasClass('review__answer-form_reload')) {
        window.location.reload(true);
    }
});

$('.reviews__edits-save').on('click', function () {
    $(this).closest('.reviews__item').find(cReviewEditsForm).submit();
});